export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  created() {}
};